import React from 'react';
import { useNavigate } from 'react-router-dom';
import bgImg from '../../assets/images/bgImg-3.png';

export default function MembersOnly() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-gray-50 flex flex-col items-center justify-start pt-12 px-4">
      <div className="w-full max-w-xl mt-12 bg-white p-8 rounded-lg shadow-md text-center">
        <h1 className="text-2xl font-bold text-pink-600 mb-4">Только для участников</h1>
        <p className="text-gray-700 mb-4">
          Эта страница доступна только участникам онлайн клуба или клиентам студии.
        </p>

        <button
          onClick={() => navigate('/onlineClub')}
          className="my-4 px-6 py-2 bg-pink-600 rounded-full shadow hover:bg-pink hover:text-white transition border border-orange-400"
        >
          Присоединиться к клубу
        </button>

        <div className="bg-pink-50 border border-purple-400 p-4 rounded-md mt-5">
          <p className="text-sm text-gray-700 mb-2">
            Если вы уверены, что произошла ошибка, пожалуйста, напишите нам в WhatsApp:
          </p>
          <a
            href="https://wa.me/972502000000" // замени на актуальный номер
            target="_blank"
            rel="noopener noreferrer"
            className="text-pink-600 hover:underline text-sm underline"
          >
            Написать в WhatsApp
          </a>
        </div>
      </div>
    </main>
  );
}
